export enum BdpName {
  SERIEN = 'SERIEN_',
  VORAB = 'VORAB_',
}
